export const i18n = {
  en: {
    common: {
      ALL: 'All',
      NO_DATA: 'No data available',
      ALERT: 'Alert',
      NO: 'No',
      YES: 'Yes',
      CLOSE: 'Close',
      WARNING: 'Warning',
      FISCAL_YEAR: 'Fiscal Year',
      RESET: 'Reset',
      DELETE: 'Delete',
      CANCEL: 'Cancel',
      SAVE: 'Save',
      APPLY: 'Apply',
      CONFIRMATION: 'Confirmation',
      SUCCESSFULLY_APPLIED: 'Successfully Applied',
      BLANK: 'Blank',
      ENGLISH: 'English',
      VIETNAMESE: 'Vietnamese',
      NOTI_LOGOUT:
        'You are already logged in on a different device. Please try again later.',
      IMPORT_FILE: 'Import file',
    },
    currencyUnit: {
      SINGLE: ' ',
      SINGLE_LABEL: 'Single Unit',
      HUNDRED: 'Hundred',
      HUNDRED_LABEL: 'Hundred',
      THOUSAND: 'Thousand',
      THOUSAND_LABEL: 'Thousand (K)',
      MILLION: 'Million',
      MILLION_LABEL: 'Million (M)',
      BILLION: 'Billion',
      BILLION_LABEL: 'Billion (B)',
      TRILLION: 'Trillion',
      TRILLION_LABEL: 'Trillion (T)',
    },
    errorCommon: {
      COMPANY_TYPE_ERROR:
        'This feature is currently unavailable for this type of company.',
      COMPANY_TYPE_ERROR_DOWNLOAD_FACTSHEET_1:
        'This feature is currently unavailable for this type of company. Please ',
      COMPANY_TYPE_ERROR_DOWNLOAD_FACTSHEET_2: 'contact us',
      COMPANY_TYPE_ERROR_DOWNLOAD_FACTSHEET_3:
        ' if you require any further information about this company.',
      ONE_TYPE_OF_INDUSTRY_USED:
        'You can select only one industry classification.',
    },
  },
  vi: {
    common: {
      ALL: 'Tất cả',
      NO_DATA: 'Dữ liệu không có sẵn',
      ALERT: 'Cảnh báo',
      NO: 'Không',
      YES: 'Có',
      CLOSE: 'Đóng',
      WARNING: 'Chú ý',
      FISCAL_YEAR: 'Năm Tài Chính',
      RESET: 'Đặt lại',
      DELETE: 'Xóa',
      CANCEL: 'Hủy',
      SAVE: 'Lưu',
      APPLY: 'Áp dụng',
      CONFIRMATION: 'Xác nhận',
      SUCCESSFULLY_APPLIED: 'Áp dụng thành công',
      BLANK: 'Trống',
      ENGLISH: 'Tiếng Anh',
      VIETNAMESE: 'Tiếng Việt',
      NOTI_LOGOUT: 'Bạn đang đăng nhập ở thiết bị khác. Vui lòng thử lại sau.',
      IMPORT_FILE: 'Thêm danh sách',
    },
    currencyUnit: {
      SINGLE: ' ',
      SINGLE_LABEL: 'Đơn vị tiền tệ',
      HUNDRED: 'Trăm',
      HUNDRED_LABEL: 'Trăm',
      THOUSAND: 'Nghìn',
      THOUSAND_LABEL: 'Nghìn',
      MILLION: 'Triệu',
      MILLION_LABEL: 'Triệu',
      BILLION: 'Tỷ',
      BILLION_LABEL: 'Tỷ',
      TRILLION: 'Nghìn Tỷ',
      TRILLION_LABEL: 'Nghìn Tỷ',
    },
    errorCommon: {
      COMPANY_TYPE_ERROR:
        'Tính năng này chưa được phát triển cho loại hình doanh nghiệp đang xem.',
      COMPANY_TYPE_ERROR_DOWNLOAD_FACTSHEET_1:
        'Tính năng này hiện không khả dụng với loại hình công ty này. Vui lòng ',
      COMPANY_TYPE_ERROR_DOWNLOAD_FACTSHEET_2: 'liên hệ với chúng tôi',
      COMPANY_TYPE_ERROR_DOWNLOAD_FACTSHEET_3:
        ' nếu bạn cần thêm thông tin chi tiết về công ty.',
      ONE_TYPE_OF_INDUSTRY_USED:
        'Vui lòng chỉ lựa chọn theo một bộ phân loại ngành',
    },
  },
}
